import {
    IAxxessIntelligenceUserTracker,
    IAxxessIntelligenceUICardGroup
} from "./../../../interfaces/i-axxess-intelligence";
import { computedFrom } from "aurelia-framework";
import nameof from "../../../common/nameof";
import { IFeedbackOption } from "../../../interfaces/i-axxess-intelligence";
import { ILinks } from "../../../interfaces/i-axxess-intelligence";

export class AxxessIntelligenceStore {
    public searchTermSync: string = "";
    public searchCount: number = 0;
    public isLoading: boolean = false;
    public isError: boolean = false;
    public searchTimeout: null | ReturnType<typeof setTimeout> = null;
    public segregatedList: IAxxessIntelligenceUICardGroup[] = [];
    public slicedData: Record<string, any> = {};
    public listOfFilters: string[] = [];
    public segregatedListFilters: string[] = [];
    public listOfLinks: ILinks[] = [];
    public isSegregatedListEmpty: boolean = true;
    public lastSearchTerm: string = "";
    public patientId: string = "";
    public accountId: string = "";
    public searchTrackingId: string = null;
    public userTracker: IAxxessIntelligenceUserTracker = {
        ExitedWithoutInteraction: true,
        SelectedResultCategory: "",
        SelectedResultIndex: null,
        SelectedResultTitle: "",
        TrackingId: null
    };
    public isFeedbackProperty = {
        isGivenFeedback: null as string,
        positiveFeedbackOptions: [
            { name: "Results were relevant", isSelected: false },
            { name: "Response was clear", isSelected: false },
            { name: "Helped me complete my task", isSelected: false },
            { name: "Other", isSelected: false }
        ] as IFeedbackOption[],

        negativeFeedbackOptions: [
            { name: "Results were irrelevant", isSelected: false },
            { name: "Response was unclear", isSelected: false },
            { name: "Did not address my question", isSelected: false },
            { name: "Other", isSelected: false }
        ] as IFeedbackOption[],
        selectedFeedbackItems: [] as string[],
        feedbackOtherOptionText: "" as string,
        isFeedbackSubmitted: false as boolean
    };

    @computedFrom(nameof<AxxessIntelligenceStore>("isFeedbackProperty"))
    public get selectedFeedbackItemsLength(): number {
        return this.isFeedbackProperty.selectedFeedbackItems.length;
    }

    public resetFeedback(): void {
        [
            ...this.isFeedbackProperty.positiveFeedbackOptions,
            ...this.isFeedbackProperty.negativeFeedbackOptions
        ].forEach((o) => (o.isSelected = false));
        this.isFeedbackProperty.selectedFeedbackItems = [];
        this.isFeedbackProperty.feedbackOtherOptionText = "";
    }
}
